export default __webpack_public_path__ + "static/mel-7e98c43acf50d35b195346a34d76ef9a.jpg";